import React from "react";
import { getStyleJSON } from "Utils/Common";
import userservice from "service/UserDataService";
import { DialogButton } from "Common/DialogButton";

export function AddUserRows() {
  const [username, setusername] = React.useState("");
  const [password, setpassword] = React.useState("");
  return (
    <>
      <tr>
        <td
          colSpan="2"
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 300px;"
          )}
        >
          Add User:
        </td>
      </tr>
      <tr ng-init="adduserconfig={}">
        <td
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 100px;"
          )}
        >
          <input
            placeholder="Username"
            style={{ width: "150px" }}
            ng-model="adduserconfig.username"
            value={username}
            onChange={(e) => {
              setusername(e.target.value);
            }} />
        </td>
        <td
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; width: 100px;"
          )}
        >
          <input
            placeholder="Password"
            style={{ width: "150px" }}
            ng-model="adduserconfig.password"
            value={password}
            onChange={(e) => {
              setpassword(e.target.value);
            }} />
        </td>
        <td
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; text-align: center; font-size: 15px"
          )}
          align="center"
        >
          <DialogButton
            label="Add"
            onClick={() => {
              userservice.addUser({ username, password });
            }} />
        </td>
      </tr>
    </>
  );
}
